/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedRelatedItems_user$ref = any;
export type SbSharedRelatedItems_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": SbSharedRelatedItems_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRelatedItems_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '3926354dfdfbdfb44725f005f65f2960';
export default node;
